export const GOOGLE_FORM_CONTACT_ACTION = 'https://docs.google.com/forms/d/e/1FAIpQLSejw5VWp-XCzX8-GaiF29piN91FGjf9nsJNxsSbCTTTVjBUJQ/formResponse?&submit=Submit??usp=pp_url&'

export const GOOGLE_FORM_NAME_ID = 'entry.1957781486'
export const GOOGLE_FORM_NICHE_ID = 'entry.1695704469'
export const GOOGLE_FORM_COMPANY_NAME_ID = 'entry.925624347'
export const GOOGLE_FORM_ROLE_ID = 'entry.509392553'
export const GOOGLE_FORM_EMAIL_ID = 'entry.964628648'
export const GOOGLE_FORM_PHONE_ID = 'entry.755883461'
export const GOOGLE_FORM_SUBJECT_ID = 'entry.1691089755'
export const GOOGLE_FORM_CHECKBOX_GROUP_ID = 'entry.2077382486'
export const GOOGLE_FORM_ACCEPT_TERMS_ID = 'entry.554332069'
